module.exports = __webpack_public_path__ + "img/fitness.d97c819.svg";